/**
 * The breakpoints the stylesheet uses, for the behaviour that has to agree
 * with it.
 *
 * bp-down(menu) in functions/_helpers.scss compiles to max-width: 1199.98px —
 * the 0.02px step keeps it from overlapping bp-up(menu). A module that moves an
 * element between its mobile and desktop homes has to switch on exactly the
 * same pixel as the rules that style it, or there is a viewport width where
 * the two disagree and the element is styled for a layout it is not in.
 *
 * menu is the header's own breakpoint, the width at which the bar hands over
 * to the mobile menu.
 */
export const BELOW_MENU = '(max-width: 1199.98px)';
